// contexts/CartContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
    const [cartItems, setCartItems] = useState([]);

    // تحميل العناصر من localStorage عند التحميل الأولي
    useEffect(() => {
        const items = JSON.parse(localStorage.getItem('cartItems')) || [];
        setCartItems(items);
    }, []);

    // حفظ التغييرات في localStorage عند كل تحديث
    useEffect(() => {
        localStorage.setItem('cartItems', JSON.stringify(cartItems));
    }, [cartItems]);
    useEffect(() => {
        const loadCartItems = () => {
            try {
                const savedItems = localStorage.getItem('cartItems');
                if (savedItems) {
                    setCartItems(JSON.parse(savedItems));
                }
            } catch (error) {
                console.error('Error loading cart items:', error);
                localStorage.removeItem('cartItems');
            }
        };
        loadCartItems();
    }, []);

    // حفظ التغييرات في localStorage
    useEffect(() => {
        try {
            localStorage.setItem('cartItems', JSON.stringify(cartItems));
        } catch (error) {
            console.error('Error saving cart items:', error);
        }
    }, [cartItems]);
    useEffect(() => {
        const loadCartItems = () => {
            try {
                const savedItems = localStorage.getItem('cartItems');
                if (savedItems) {
                    const parsedItems = JSON.parse(savedItems);
                    // تحقق من صحة الهيكل
                    if (Array.isArray(parsedItems) && parsedItems.every(item => item.slug)) {
                        setCartItems(parsedItems);
                    } else {
                        throw new Error('Invalid cart data structure');
                    }
                }
            } catch (error) {
                console.error('Error loading cart:', error);
                localStorage.removeItem('cartItems');
                setCartItems([]);
            }
        };
        loadCartItems();
    }, []);
    const addToCart = (item) => {
        setCartItems(prev => {
            const existingItem = prev.find(i => i.slug === item.slug);
            return existingItem ? prev : [...prev, { ...item, quantity: 1 }];
        });
    };

    const removeFromCart = (slug) => {
        setCartItems(prev => prev.filter(item => item.slug !== slug));
    };

    const updateQuantity = (slug, quantity) => {
        setCartItems(prev =>
            prev.map(item =>
                item.slug === slug ? { ...item, quantity: Math.max(1, quantity) } : item
            )
        );
    };

    const clearCart = () => {
        setCartItems([]);
    };

    return (
        <CartContext.Provider
            value={{
                cartItems,
                addToCart,
                removeFromCart,
                updateQuantity,
                clearCart,
            }}
        >
            {children}
        </CartContext.Provider>
    );
};

export const useCart = () => useContext(CartContext);